import { render, staticRenderFns } from "./HomeModule.vue?vue&type=template&id=581e2ec4&"
import script from "./HomeModule.vue?vue&type=script&lang=js&"
export * from "./HomeModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports